<div class="border">
  <ag-grid-angular
  style="width: 100%; height: 100%;"
  (gridReady)="onGridReady($event)"
  [gridOptions]="gridOptions"
  [masterDetail]="masterDetail"
  />
</div>
